module.exports = __webpack_public_path__ + "img/goods2_5.f4d8f62f.jpg";